import React, { useContext, useMemo } from 'react'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import { useTranslation } from 'react-i18next'

import { Modal } from 'components/Modal'
import Button from 'components/Button'
import { RestaurantContext } from 'sections/options/sections/RestaurantDesigner/RestaurantDesignerHandler'
import { Form, Text, Number as InputNumber } from 'components/forms'
import { useMutation } from 'components/graphql'
import { FloorsContext } from './FloorsBlocksContainers'
import { mutation } from '../../helpers'
import themeStyle from 'config/theme'

import {
	StyledFormBlock,
	StyledButtonBlock,
	StyledFloorInput
} from './styled'


const FloorModal = ({ mutations: { create: { rawCreateFloor }, update: { rawUpdateFloor } }, floorItem = null }) => {
	const { currentProjectData, currentProjectIds, setCurrentProjectIds } = useContext(RestaurantContext)
	const { showModal, setShowModal, setModalFloor } = useContext(FloorsContext)
	const [createFloor] = useMutation(rawCreateFloor)
	const [updateFloor] = useMutation(rawUpdateFloor)
	const [t] = useTranslation()
	const isCreate = (floorItem === null) || isEmpty(floorItem)

	const handleCreate = (number) => mutation(createFloor, {
		fields: {
			projectId: currentProjectData.projectData.id,
			number
		},
		defaultRoomCaption: t('restaurant_designer_section.strings.default_room_name')
	}).then(()=>{
		setShowModal(false)
		setModalFloor(null)
	})

	const handleUpdate = (fields) => mutation(updateFloor, { fields })
		.then((res)=>{
			setCurrentProjectIds({
				projectId: currentProjectIds.projectId,
				floorId: res.data.cashAssist.updateFloor[0].id,
				roomId: get(res.data.cashAssist.updateFloor[0], 'rooms[0].id', null) })
			setModalFloor(null)
			setShowModal(false)
		})
		.catch(error => {
			console.error('[FLOOR UPDATE ERROR]: \n\n', error, '\n', { error })
		})


	const getInitialCreationNumber = () => {
		let nextNumber
		if(currentProjectData.projectData.floors.length !== 0) {
			currentProjectData.projectData.floors.forEach((item, key) => {
				if(!nextNumber) {
					if(key === 0 && item.number > 1) {
						nextNumber = item.number - 1
						return
					}
					const nextFloor = currentProjectData.projectData.floors[key + 1]
					if(nextFloor) {
						if(item.number !== nextFloor.number - 1) {
							nextNumber = item.number + 1
							return
						}
					}
				}
				return
			})

			if(!nextNumber) {
				nextNumber = currentProjectData.projectData.floors.length + 1
			}
			return nextNumber
		}
		return 1
	}

	const validations = () => ({
		validate: (value) => {
			let error = null
			if(!value) {
				error = t('restaurant_designer_section.validations.floor_number_empty')
			} else if(currentProjectData.projectData.floors.find(item=>item.number === value)) {
				error = t('restaurant_designer_section.validations.floor_number_exist')
			}
			return error
		}
	})
	const initialValues = !isCreate
		? { id: floorItem.id, number: floorItem.number }
		: { number: getInitialCreationNumber() }
	return showModal && <Modal unmount={() => {
		setModalFloor(null)
		setShowModal(false)
	}}
	width={420}
	label={t('restaurant_designer_section.strings.floor_modal_header_label')}>
		<div>
			<Form
				key={currentProjectData.projectData.floors.length}
				onSubmit={(fields) => isCreate ? handleCreate(Number(fields.number)) : handleUpdate(fields)}
				initialValues={initialValues}
				render={({ formApi, formState }) => (
					<>
						<StyledFormBlock>
							<Text field={'id'} hidden/>
							<StyledFloorInput>
								<InputNumber
									label={t('restaurant_designer_section.fields.floor_modal_input_label')}
									field={'number'}
									{...validations()}
								/>
							</StyledFloorInput>
						</StyledFormBlock>
						<StyledButtonBlock>
							<Button style={{ width: '180px' }} theme={themeStyle} status={'cancelation'} text={t('common.buttons.abort')} onClick={()=>{
								setShowModal(false)
								setModalFloor(null)
							}}/>
							<Button style={{ width: '180px' }} theme={themeStyle} status={'primary'} type='submit' text={t('common.buttons.save')}
							/>
						</StyledButtonBlock>
					</>
				)}/>

		</div>
	</Modal>
}


export default FloorModal
